/**
 *
 * Asynchronously loads the component for TestSelectPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
